import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Lotto} from '../_models/Lotto';
import {environment} from '../../environments/environment';
import {CaratteristicaSchedaTecnica} from "../_models/CaratteristicaSchedaTecnica";
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LottiService {
  constructor(private http: HttpClient) {}

  async createLottoAsync(orgId: number, lotto: Lotto) {
    return firstValueFrom(this.http.post<Lotto>(`${environment.localApiUrl}api/Lotti/CreateLotto/${orgId}`, lotto));
  }

  async leggiLottoAsync(orgId: number, lotto: Lotto) {
    return firstValueFrom(this.http.post<Lotto>(`${environment.localApiUrl}api/Lotti/LeggiLotto/${orgId}`, lotto));
  }

  async verificaLottoAsync(orgId: number, lotto: Lotto) {
    return firstValueFrom(this.http.post<Lotto>(`${environment.localApiUrl}api/Lotti/VerificaLotto/${orgId}`, lotto));
  }

  async importaCaratteristicaLottoAsync(orgId: number, caratteristica: CaratteristicaSchedaTecnica) {
    return firstValueFrom(this.http.post<CaratteristicaSchedaTecnica>(`${environment.localApiUrl}api/Lotti/ImportaCaratteristica/${orgId}`, caratteristica));
  }
}
